import { publicClient, privateClient } from "../../configs/axiosConfig";

const userEndpoints = {
  signin: "v1/user/signin",
  signup: "v1/user/signup",
  getInfo: "v1/user/info",
  updatePassword: "v1/user/update-password",
  updateProfile: "v1/user/userUpdate",
  getAllOperator: "v1/user/allOperator",
  forgotPassword: "v1/user/forgot-password",
  getAllOperatorPublic: `v1/user/getpublicoperatorfromuser?key=${process.env.REACT_APP_REMINDER_CRON_SECRET}`,

  requestOTP: "v1/user/request-otp",
  verifyOTP: "v1/user/verify-otp",
};

const userApi = {
  signin: async ({ username, password }) => {
    try {
      const response = await publicClient.post(userEndpoints.signin, {
        username,
        password,
      });

      return { response };
    } catch (err) {
      console.error("Sign in API Error:", err.response?.data || err.message);
      return { err: err.response?.data || { message: err.message } };
    }
  },

  signup: async (values) => {
    try {
      const response = await publicClient.post(userEndpoints.signup, values);
      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },

  requestOtp: async ({ email }) => {
    try {
      const response = await publicClient.post(userEndpoints.requestOTP, {
        email,
      });

      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },

  verifyOtp: async ({ email, otp }) => {
    try {
      const response = await publicClient.post(userEndpoints.verifyOTP, {
        email,
        otp,
      });

      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },
  getInfo: async () => {
    try {
      const response = await privateClient.get(userEndpoints.getInfo);

      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },

  getAllOperator: async () => {
    try {
      const response = await privateClient.get(userEndpoints.getAllOperator);
      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },
  getAllOperatorPublic: async () => {
    try {
      const response = await publicClient.get(
        userEndpoints.getAllOperatorPublic,
      );

      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },
  updateProfile: async (data) => {
    try {
      const response = await privateClient.put(
        userEndpoints.updateProfile,
        data,
      );
      return response;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Profile update failed");
    }
  },
  passwordUpdate: async ({ password, newPassword, confirmNewPassword }) => {
    try {
      const response = await privateClient.put(userEndpoints.updatePassword, {
        password,
        newPassword,
        confirmNewPassword,
      });

      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },
  forgotPassword: async (email) => {
    try {
      const response = await publicClient.post(userEndpoints.forgotPassword, {
        email,
      });
      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },
  resetPassword: async (token, password) => {
    try {
      const response = await publicClient.post(
        `/v1/user/reset-password/${token}`,
        {
          password,
        },
      );
      return { response };
    } catch (err) {
      return { err: err.response?.data || { message: err.message } };
    }
  },
};

export default userApi;
